import { useDetailOrderAttachments, useResourceType } from "hooks";
import {
  useDeleteResource,
  useDownloadMultipleResources,
  useResourceGlobalPreview,
} from "hooks/resource-global/useResourceGlobal";
import OrderDetailAttachments from "pages/MyOrders/OrderDetail/OrderDetailAttachments/OrderDetailAttachments";
import React, { useEffect, useState } from "react";
import { Row } from "reactstrap";

const TransferOrderAttachment = props => {
  const { orderId } = props;

  const [userType, setUserType] = useState();
  const [resourceId, setResourceId] = useState(null);

  // download multiple resources
  const onSuccessDownloadMultipleResources = data => {
    if (!!data) {
      var url = window.URL || window.webkitURL;
      const urlData = url.createObjectURL(
        new Blob([data], { type: "application/zip" })
      );
      const link = document.createElement("a");
      link.href = urlData;
      link.target = "_blank";
      link.setAttribute("download", "Attachments.zip");
      document.body.append(link);
      link.click();
      document.body.removeChild(link);
      url.revokeObjectURL(urlData);
    }
  };
  const onErrorDownloadMultipleResources = error => {};

  //get resource type
  const { data: resourceType } = useResourceType();

  // order detail attachments
  const {
    refetch: fetch_orderDetailAttachments,
    data: attachments,
    isLoading: isAttachmentsLoading,
  } = useDetailOrderAttachments({
    orderId: orderId,
  });

  // resource global preview
  const {
    data: resourceData,
    isLoading: isLoadingResource,
    refetch: fetchResourceGlobalPreview,
  } = useResourceGlobalPreview({
    resourceId: resourceId,
  });

  const {
    mutate: downloadMultipleResources,
    isLoading: isDownloadingMultipleResources,
  } = useDownloadMultipleResources(
    onSuccessDownloadMultipleResources,
    onErrorDownloadMultipleResources
  );

  // delete resource
  const onDeleteResourceSuccess = data => {
    fetch_orderDetailAttachments();
  };

  const { mutate: deleteResource, isLoading: isDeletingResource } =
    useDeleteResource(onDeleteResourceSuccess, () => {});

  const getImagePreview = id => {
    setResourceId(id);
  };
  const dowloadMultipleResources = ids => {
    downloadMultipleResources(ids);
  };

  useEffect(() => {
    setUserType(localStorage.getItem("user_type"));
  }, []);

  useEffect(() => {
    setResourceId(resourceId);
  }, [orderId]);

  useEffect(() => {
    if (resourceId) {
      fetchResourceGlobalPreview();
    }
  }, [resourceId]);
  useEffect(() => {
    if (orderId) {
      fetch_orderDetailAttachments(orderId);
    }
  }, [orderId]);

  return (
    <Row>
      <OrderDetailAttachments
        data={attachments}
        resourceType={resourceType}
        userType={userType}
        resourceData={resourceData}
        isLoading={isAttachmentsLoading}
        isLoadingResource={isLoadingResource}
        isDownloadingMultipleResources={isDownloadingMultipleResources}
        isDeletingResource={isDeletingResource}
        getImagePreview={getImagePreview}
        dowloadMultipleResources={dowloadMultipleResources}
        deleteResource={id => {
          deleteResource(id);
        }}
      />
    </Row>
  );
};

export default TransferOrderAttachment;
